<div [ngClass]="{'is-sticky': !isLoading}" class="notification is-primary explanation" *ngIf="renderCount && showExplanation" [@slideDown]>
    <button class="delete" (click)="showExplanation = false"></button>
    <p>Drag nodes from the <strong>XPath query</strong> or the <strong>tree</strong> into the analysis table below to
        analyse its properties. Multiple nodes can be selected by clicking on them.</p>
</div>
<div class="columns query" [ngClass]="{'disabled': disabled}">
    <div class="column" [ngClass]="{'is-half': treeXml}">
        <h2 class="subtitle" style="height: 2.5rem">XPath</h2>
        <div class="content">
            <grt-xpath-viewer [value]="xpath" [variables]="nodes" [selectedVariables]="selectedNodes"
                (partClick)="nodeClick($event.variableName)"></grt-xpath-viewer>
            <p class="has-text-right">
                <a class="button is-secondary is-inverted mt-2" [ngClass]="{'is-invisible': selectedNodesCount < 1}" (click)="deselectNodes()">deselect nodes</a>
            </p>
        </div>
    </div>
    <div class="column" *ngIf="treeXml">
        <h2 class="subtitle">
            <div class="level">
                <div class="level-item level-left">
                    Tree
                </div>
                <div class="level-item level-right is-hidden-print">
                    <p class="control" tooltipPosition="bottom"
                    pTooltip="Full screen display of the tree.">
                        <a class="button" role="button" (click)="treeDisplay = 'both'" >
                            <span class="icon is-large">
                                <fa-icon [icon]="faExpand" aria-hidden="true"></fa-icon>
                            </span>
                        </a>
                    </p>
                </div>
            </div>
        </h2>
        <grt-tree-visualizer [xml]="treeXml" [display]="treeDisplay" [fullScreenButton]="false"
            [selectedNodes]="selectedNodes" (displayChange)="treeDisplay = $event"
            (nodeClick)="nodeClick($event)"></grt-tree-visualizer>
        <p class="has-text-right">
            <a class="button is-secondary is-inverted mt-2" [ngClass]="{'is-invisible': selectedNodesCount < 1}" (click)="deselectNodes()">deselect nodes</a>
        </p>
    </div>
</div>
<div class="modal is-active" *ngIf="selectedVariable" [@slideDown]>
    <div class="modal-background"></div>
    <div class="modal-content">
        <div class="box" *ngIf="custom">
            <grt-node-properties (add)="addVariable($event)" [nodeName]="selectedVariable.nodes[0].name">
            </grt-node-properties>
            <div class="level">
                <div class="level-left">
                    <a role="button" (click)="custom=false">
                        Show Existing Properties...
                    </a>
                </div>
                <div class="level-right">
                    <div class="buttons is-right">
                        <div class="button is-secondary" role="button" (click)="cancelVariable()">
                            Cancel
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="box" *ngIf="!custom">
            <div class="content">
                Which property of
                <span class="tag" *ngFor="let node of selectedVariable.nodes">{{node.name}}</span> should be analyzed?
            </div>
            <grt-xpath-viewer *ngFor="let node of selectedVariable.nodes" [value]="node.path"></grt-xpath-viewer>
            <br />
            <div class="field">
                <ng-select [(ngModel)]="selectedVariable.attribute" required="true">
                    <ng-option *ngFor="let attribute of nodeAttributes" [value]="attribute.value">
                        {{attribute.label}}
                    </ng-option>
                </ng-select>
            </div>
            <div class="level">
                <div class="level-left">
                    <a role="button" (click)="custom=true">
                        Specify Custom Properties...
                    </a>
                </div>
                <div class="level-right">
                    <div class="buttons is-right">
                        <div class="button is-secondary" role="button" (click)="cancelVariable()">
                            Cancel
                        </div>
                        <div class="button is-primary" role="button" (click)="addVariable()">
                            Add
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <button class="modal-close is-large" aria-label="close" (click)="cancelVariable()"></button>
</div>
<div class="level">
    <div class="level-left">
        <h1 class="title" [ngClass]="{'is-loading': isLoading}" grtSubtitle>Analysis Table</h1>&nbsp;
    </div>
    <div class="level-right">
        <div class="level-item" *ngIf="canShowMore" pTooltip="More data is ready to be shown in the table" tooltipPosition="bottom">
            <a class="button has-badge-rounded" [ngClass]="{'has-badge-warning': isLoading}" role="button"
                (click)="showMore()" [attr.data-badge]="hitsCount - renderCount | transitionNumbers">
                Show More Data
            </a>
        </div>
    </div>
</div>
<div class="analysis-box" [ngClass]="{'box': renderCount}">
    <div class="content" [@slideDown] *ngIf="renderCount">
        <p>Click on a cell in the table to view those documents.</p>
    </div>
    <div class="analysis-component" [ngClass]="{'disabled': disabled}"></div>
</div>
